import React, { useContext } from "react";
import { Input, Progress } from "reactstrap";
import FormRenderer from "./FormRenderer";
import {
  type IInputRendererProps,
  InputRendererContext,
} from "./InputRenderer";

export const FileUploadRendererContext: React.Context<
  ProgressEvent | undefined
> = React.createContext(undefined);

export interface IFileUploadRendererProps extends IInputRendererProps {
  type: never;
}

export default ({
  input,
  meta,
  label,
  formText,
  tooltip,
  ...rest
}: IFileUploadRendererProps) => {
  const { value, ...inputRest } = input;
  const { error, submitting } = meta;
  const contextProps = useContext(InputRendererContext);
  const progressEvent = useContext(FileUploadRendererContext);
  return (
    <FormRenderer
      input={input}
      meta={meta}
      label={label}
      type="file"
      formText={formText}
      alwaysShowLabel
      tooltip={tooltip}
    >
      <Input
        {...inputRest}
        {...rest}
        {...contextProps}
        type="file"
        className="form-control"
        invalid={!!error}
        disabled={rest.disabled || submitting}
      />

      {progressEvent && (
        <Progress
          value={(progressEvent.loaded / progressEvent.total) * 100}
          className="mt-3"
        />
      )}
    </FormRenderer>
  );
};
